import React from 'react';

import { Typography } from "@material-ui/core"

import Page from "../../Components/Page"

export default () => {
    return (
        <Page title="Queerdenker Festival 2.0 – Design">
            <Typography>
                Das ist der Styleguide für das Queerdenker Festival 2020.
            </Typography>
        </Page>
    )
}